<div id="divLogin" class="contenedor">
  <div class="layer">
    <form [formGroup]="formulario" class="example-form">
      <mat-card class="example-card">
        <div>
           <br>
            <img mat-card-image class="card-login" src="./assets/profile.png" alt="Photo of a Shiba Inu">
          </div>
        <mat-card-content>

          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="Usuario" formControlName="username" name="username" required>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="Clave" type="password" formControlName="password" name="password" required>
                </mat-form-field>
              </td>
            </tr>
          </table>
          <mat-spinner [diameter]="30" *ngIf="iniciandoSesion" style="margin:0 auto; top:15px;"></mat-spinner>
        </mat-card-content>
        <mat-card-actions class="button-login">
          <button mat-raised-button (click)="onSubmit()" color="primary">
            <mat-icon>input</mat-icon>
            Login
          </button>
        </mat-card-actions>
        <label class="versionLabel">{{ambienteVersion}}</label>
      </mat-card>
    </form>
  </div>
</div>
